import React from 'react';
import { useState, useEffect } from "react";
import EditableField from "../common/EditableField.tsx";
import type { Schema } from "../../amplify/data/resource.js";
import { generateClient } from "aws-amplify/data";

  const client = generateClient<Schema>();

  export default function PRStrategies() {
    const [cards, setCards] = useState<Schema["PrStrategies"]["type"][]>([]);

    const handleSentimentChange = async (index, newSentiment) => {
      setCards(prevCards => {
        const updatedCards = prevCards.map((card, i) => i === index ? {
          ...card, sentiment: newSentiment } : card);

        return updatedCards;
      });

      await new Promise(r => setTimeout(r, 0));

      const updatedCard = cards[index];

      await client.models.PrStrategies.update({
        id: updatedCard.id,
        date: new Date().toISOString(),
        enteredBy: "Developer entry",
        category: updatedCard.category,
        sentiment: updatedCard.sentiment,
        description: updatedCard.description,
      });
    };

    useEffect(() => {
      let sub = client.models.PrStrategies.observeQuery().subscribe({
        next: ({ items }) => {
          setCards([...items].sort((a, b) => a.id - b.id));
        }
      });
      return () => sub.unsubscribe();
    }, []);

  return (
    <div className="dashboard">
      <h1>PR Strategies</h1>
        <p>
          Results of public relations and external communications strategies to achieve positive media coverage
          and manage reputational risks.
        </p>
        <br />
     <div className="boxes">
      {cards.map((card, index) => (
        <EditableField
          key={index}
          id={card.id}
          category={card.category}
          sentiment={card.sentiment}
          content={card.description}
          dashboardType="PrStrategies"
          onChange={newSentiment => handleSentimentChange(index, newSentiment)}
        />
      ))}
    </div>
    </div>
  );
}